import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "../config/RequestMethod";

// Create axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check if error is due to token expiration (403 or 401)
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401) &&
      error.response.data.message &&
      (error.response.data.message.includes("jwt expired") ||
        error.response.data.message.includes("TokenExpiredError") ||
        error.response.data.message.includes("inactive") ||
        error.response.data.message === "Unauthorized")
    ) {
      // Clear all auth data
      Cookies.remove("token");
      localStorage.removeItem("persist:root"); // Clear Redux persist storage

      // Set logout message
      Cookies.set(
        "logoutMessage",
        "Your session has expired. Please login again.",
        {
          path: "/",
          secure: false,
        }
      );

      // Redirect to login
      window.location.href = "/login";

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
